document.addEventListener('click', function(e){
  const toggle=e.target.closest('.btc-menu-toggle');
  if(toggle){
    const nav=document.getElementById('btc-main-nav');
    if(nav){
      const open=nav.classList.toggle('is-open');
      toggle.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
    }
    return;
  }

  const a=e.target.closest('a[href^="#"]');
  if(!a) return;
  const id=a.getAttribute('href');
  if(id.length>1){
    const el=document.querySelector(id);
    if(el){
      e.preventDefault();
      const nav=document.getElementById('btc-main-nav');
      const menuToggle=document.querySelector('.btc-menu-toggle');
      if(nav) nav.classList.remove('is-open');
      if(menuToggle){ menuToggle.classList.remove('is-open'); menuToggle.setAttribute('aria-expanded','false'); }
      document.body.classList.remove('menu-open');
      el.scrollIntoView({behavior:'smooth',block:'start'});
    }
  }
});
